<script lang="ts">
  // Abschnitt „Commits" im Baum des Bereichs Claude (baum.svelte.ts): der
  // Verlauf des gezeigten Repos, jüngster oben (Tim 16.10.2026: „noch einen
  // Abschnitt mit dem Repo selbst, wo die Commits liegen"). Ein Klick zeigt,
  // was der Commit geändert hat (pages/ClaudeAenderung.svelte), als Vorschau;
  // Doppelklick heftet an. Nicht gepusht: gelber Pfeil.
  import Icon from "../Icon.svelte";
  import { getClaude } from "../claude-summary.svelte";
  import { t } from "../i18n.svelte";
  import { oeffnePfad } from "../shell/route-sync.svelte";
  import { istPfadAktiv } from "../shell/tabs.svelte";
  import { gezeigtesRepo } from "./baum.svelte";
  import { aenderungPfad, repoStandFuer, wannKurz } from "./claude";

  const repo = $derived(gezeigtesRepo());
  const verlauf = $derived(repoStandFuer(getClaude()?.stand, repo)?.verlauf ?? []);
  let jetzt = $state(new Date());
  $effect(() => {
    const iv = setInterval(() => (jetzt = new Date()), 60_000);
    return () => clearInterval(iv);
  });
</script>

<div class="grid pb-2">
  {#each verlauf as c (c.hash)}
    {@const pfad = aenderungPfad(repo, { commit: c.hash })}
    <button
      type="button"
      class="zeile"
      data-zeile
      class:aktiv={istPfadAktiv(pfad)}
      title={`${c.kurz} · ${c.autor ?? ""}${c.gepusht ? "" : " · " + t("claude.aend.nicht_gepusht", "nicht gepusht")}\n${c.titel}`}
      onclick={() => oeffnePfad(pfad, { vorschau: true })}
      ondblclick={() => oeffnePfad(pfad)}
    >
      {#if c.gepusht}
        <span class="punkt" aria-hidden="true"></span>
      {:else}
        <span class="pfeil"><Icon name="upload" size={12} /></span>
      {/if}
      <span class="truncate">{c.titel}</span>
      <span class="tail tabular-nums">{wannKurz(c.zeit, jetzt)}</span>
    </button>
  {:else}
    <p class="text-fg-subtle t-meta px-3 py-1" data-zeile>{t("claude.baum.keine_commits", "Noch keine Commits.")}</p>
  {/each}
</div>

<style>
  /* Wie eine Baumzeile (TreeNode.svelte). */
  .zeile {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    min-width: 0;
    padding: 0.2rem 0.75rem 0.2rem 1.25rem;
    margin: 1px 0.35rem 1px 0;
    font-size: 0.84rem;
    color: var(--fg);
    text-align: left;
    border-radius: 0.4rem;
  }
  .zeile:hover {
    background: var(--bg-elev);
  }
  .zeile.aktiv {
    background: color-mix(in srgb, var(--fg) 11%, transparent);
    font-weight: 600;
  }
  .punkt {
    width: 0.8rem;
    flex: none;
    display: grid;
    place-items: center;
  }
  .punkt::before {
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--fg-subtle);
  }
  .pfeil {
    width: 0.8rem;
    flex: none;
    display: grid;
    place-items: center;
    color: var(--warning);
  }
  .tail {
    margin-left: auto;
    padding-left: 0.4rem;
    font-size: 0.74rem;
    color: var(--fg-subtle);
    white-space: nowrap;
  }
</style>
